// extracted by mini-css-extract-plugin
export default {"belowTheFoldWrapper":"belowTheFoldWrapper__bN078","belowTheFoldContentWrapper":"belowTheFoldContentWrapper__G3F8V","mediaContentAnimation":"mediaContentAnimation__qklPv","visible":"visible__qduT3","show":"show__VwGiP","hide":"hide__v1YaN","contentImage":"contentImage__LSXu2","trailerThumbnail":"trailerThumbnail__Qb0hI","imageThumbnailWrapper":"imageThumbnailWrapper__B7Rxr","thumbnailFrame":"thumbnailFrame__Zy9mx"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"belowTheFoldWrapper\":\"belowTheFoldWrapper__bN078\",\"belowTheFoldContentWrapper\":\"belowTheFoldContentWrapper__G3F8V\",\"mediaContentAnimation\":\"mediaContentAnimation__qklPv\",\"visible\":\"visible__qduT3\",\"show\":\"show__VwGiP\",\"hide\":\"hide__v1YaN\",\"contentImage\":\"contentImage__LSXu2\",\"trailerThumbnail\":\"trailerThumbnail__Qb0hI\",\"imageThumbnailWrapper\":\"imageThumbnailWrapper__B7Rxr\",\"thumbnailFrame\":\"thumbnailFrame__Zy9mx\"}";
        // 1787130556883
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  